<app-layout>
  <app-voltar route="listagem/higienizacao-agendada" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>
  <div class="forms">
    <form [formGroup]="form">
      <app-subtitulo>
        Informe o número do agendamento de higienização para sequência do
        processo
      </app-subtitulo>
      <div class="formList">
        <app-input
          type="number"
          label="N° do Agendamento"
          name="FK_AGND"
          formControlName="FK_AGND"
          placeholder="Digite o número do agendamento"
          mask="0000000000"
          (blurEvent)="getAgendamento()"
          [requiredInput]="true"></app-input>
        <app-input
          type="disabled"
          label="Data e Horário da Fila"
          placeholder="Aguardando"
          name="DT_FILA"
          formControlName="DT_FILA"
          [disabled]="true"></app-input>
        <app-input
          type="select"
          label="Tipo da Carreta"
          name="FK_TIPO_CRRT"
          formControlName="FK_TIPO_CRRT"
          placeholder="Digite aqui"
          [selectData]="tipoCarretaOptions"
          (ngModelChange)="onSelectChange($event, 'FK_TIPO_CRRT')"
          [requiredInput]="true"></app-input>
        <app-input
          type="select"
          label="Quantidade de Eixos"
          name="QT_TOTL_EIXO"
          formControlName="QT_TOTL_EIXO"
          placeholder="Digite aqui"
          [selectData]="tipoEixosOptions"
          (ngModelChange)="onSelectChange($event, 'QT_TOTL_EIXO')"></app-input>
        <app-input
          type="select"
          label="Quantidade de Compartimentos"
          name="QT_CPTM"
          formControlName="QT_CPTM"
          placeholder="Digite aqui"
          [selectData]="qtdCompartimentosOptions"
          (ngModelChange)="onSelectChange($event, 'QT_CPTM')"></app-input>
        <app-input
          type="select"
          label="Tipo de Carga"
          name="FK_CRGA"
          formControlName="FK_CRGA"
          placeholder="Digite aqui"
          [selectData]="tipoCargaOptions"
          (ngModelChange)="onSelectChange($event, 'FK_CRGA')"
          [requiredInput]="true"></app-input>
        <app-input
          type="text"
          label="Observação:"
          name="TX_OBSV_SRVC_ENTR"
          formControlName="TX_OBSV_SRVC_ENTR"
          placeholder="Digite aqui"></app-input>
        <app-input
          type="select"
          label="Tabela de Preço (Higienização)"
          id="tabelaPreco"
          name="PK_PRCO"
          formControlName="PK_PRCO"
          [selectData]="precosOptions"
          (ngModelChange)="onPrecoSelecionado($event)"></app-input>
      </div>
      <app-botao
        *ngIf="!isViewing"
        type="cadastro"
        class="botao-cadastro"
        text="Confirmar Higienização"
        (click)="postHigienizacao()"
        [disabled]="!form.valid || !form.get('PK_PRCO')?.value"></app-botao>
    </form>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
